import { useState } from "react";
import { Cake, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** Optional birthday (month + day only) → birthday email with bonus minutes on the next session. */
export function BirthdayCard({ m, token, onChange }) {
  const [month, setMonth] = useState(m.birthday_md ? Number(m.birthday_md.slice(0, 2)) : 0);
  const [day, setDay] = useState(m.birthday_md ? Number(m.birthday_md.slice(3, 5)) : 0);
  const [busy, setBusy] = useState(false);
  const saved = m.birthday_md ? `${MONTHS[Number(m.birthday_md.slice(0, 2)) - 1]} ${Number(m.birthday_md.slice(3, 5))}` : null;

  const save = async () => {
    setBusy(true);
    try { const r = await api.post(`/memberships/public/${token}/birthday`, { month, day }); onChange(r.data); toast.success("Birthday saved — expect a little something from David"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Couldn't save"); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    setBusy(true);
    try { const r = await api.delete(`/memberships/public/${token}/birthday`); onChange(r.data); setMonth(0); setDay(0); toast.success("Birthday removed"); }
    catch { toast.error("Couldn't remove"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 rounded-xl border border-slate-800 bg-slate-900/50 p-4 text-sm" data-testid="membership-birthday">
      <div className="flex items-start gap-3">
        <Cake className="w-5 h-5 text-[#FFD600] shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="font-display font-semibold">Birthday perk</div>
          {m.bonus_minutes > 0 && <div className="mt-1 text-[#FFD600]" data-testid="membership-bonus-minutes">+{m.bonus_minutes} bonus minutes waiting on your next session — book with this email and they're added automatically.</div>}
          {saved
            ? <p className="text-slate-400 mt-1" data-testid="membership-birthday-saved">Saved: <strong className="text-slate-200">{saved}</strong>. On the day you'll get a note from David and 15 bonus minutes on your next session. <button type="button" onClick={remove} disabled={busy} className="dg-link" data-testid="membership-birthday-remove">Remove</button></p>
            : <>
              <p className="text-slate-400 mt-1">Tell us your birthday (just the month and day) and David will send a little something — 15 bonus minutes on your next session.</p>
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <select className="dg-input w-40 text-sm" value={month} onChange={(e) => setMonth(Number(e.target.value))} data-testid="membership-birthday-month">
                  <option value={0}>Month</option>
                  {MONTHS.map((n, i) => <option key={n} value={i + 1}>{n}</option>)}
                </select>
                <select className="dg-input w-24 text-sm" value={day} onChange={(e) => setDay(Number(e.target.value))} data-testid="membership-birthday-day">
                  <option value={0}>Day</option>
                  {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
                <button type="button" onClick={save} disabled={!month || !day || busy} className="dg-btn-ghost rounded-full px-4 py-2 text-sm flex items-center gap-1 disabled:opacity-40" data-testid="membership-birthday-save">
                  {busy && <Loader2 className="w-3 h-3 animate-spin" />} Save
                </button>
              </div>
            </>}
        </div>
      </div>
    </div>
  );
}
